import {
  Outlet,
  createFileRoute,
  getRouteApi,
  redirect,
} from "@tanstack/react-router";
import { useEffect } from "react";

import { AdminNavBar } from "@/components/admin-navigation-bar";
import { loadSession, rememberSession } from "@/lib/session";

const adminRoute = getRouteApi("/admin");

const AdminLayout = () => {
  const { session } = adminRoute.useRouteContext();

  useEffect(() => {
    rememberSession(session);
  }, [session]);

  return (
    <>
      <AdminNavBar session={session} />
      <div className="px-4 py-8 sm:px-6 lg:px-10 lg:py-12">
        <Outlet />
      </div>
    </>
  );
};

export const Route = createFileRoute("/admin")({
  beforeLoad: async () => {
    const session = await loadSession();

    if (!session.user || !session.staff) {
      throw redirect({ to: "/login" });
    }

    return { session };
  },
  component: AdminLayout,
});
